export default __webpack_public_path__ + "images/eurs_e40bdb.svg";